import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './css/dist/semantic.css';
import { Provider } from 'react-redux';
import { createStore } from 'redux'
import reducer from './reducer';

const store = createStore(reducer, {
  artScroller: {},
  sizing: {
    windowSize: { width: 1024, height: 768 }
  }
})

ReactDOM.render(
  <Provider store={store}><App /></Provider>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js